import { h } from 'vue';
import { SettingsEntry } from '../settings-entry';
import FormToggle from '@frontend/components/FormToggle';
import { img } from '@phi/components';
import app from '@frontend/application-container';
import icon from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/Top/search/labels.svg';

export function ShowHideLabels() {
    return SettingsEntry(
        'Button labels',

        'Show labels in the top bar.',

        img(icon, 'Show/hide labels'),

        h(FormToggle, {
            value: app.settings.labels,
            'onUpdate:value': x => app.settings.labels = x,
        }),
    );
}
